const updates = [
  {
    date: '2026-07-30',
    title: '台北娜娜最新直播间名场面合集上线',
    desc: '整理台北娜娜近一周直播精彩片段，包含多个搞笑吃瓜瞬间和突发翻车现场。',
    tag: 'NEW',
  },
  {
    date: '2026-07-29',
    title: '玩偶姐姐回应争议：全文实录发布',
    desc: '玩偶姐姐首次正面回应近期网络争议，51吃瓜为你还原事件全貌。',
    tag: 'HOT',
  },
  {
    date: '2026-07-28',
    title: '莫里秀轻量版短视频专区全新升级',
    desc: '莫里秀专区播放体验优化，新增离线缓存功能，看吃瓜短视频更流畅。',
    tag: '',
  },
  {
    date: '2026-07-27',
    title: '网红直播翻车合集播放量破千万',
    desc: '吃瓜娱乐现场推出的网红直播翻车特辑，全网播放量突破千万大关。',
    tag: '',
  },
  {
    date: '2026-07-26',
    title: '吃瓜真人秀片段新版块内测中',
    desc: '全新吃瓜真人秀片段版块即将上线，更多精彩名场面等你发现。',
    tag: '',
  },
  {
    date: '2026-07-25',
    title: '51吃瓜爆料网用户突破千万',
    desc: '感谢每一位吃瓜爱好者的支持！我们持续优化产品体验，带来更多热播吃瓜短视频。',
    tag: 'HOT',
  },
  {
    date: '2026-07-24',
    title: '搞笑吃瓜瞬间周榜揭晓',
    desc: '本周搞笑吃瓜瞬间TOP10榜单揭晓，来看看哪些名场面最受欢迎。',
    tag: '',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          吃瓜快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          最新动态 · 实时追踪
        </p>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="relative flex gap-4 md:gap-6 pb-8 last:pb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-3 h-3 rounded-full mt-1.5 ${
                  item.tag === 'NEW' ? 'bg-accent-500' : item.tag === 'HOT' ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-2"></div>
                )}
              </div>
              <div className="flex-1 min-w-0 pb-1">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  {item.tag && (
                    <span className={`px-1.5 py-0.5 rounded text-xs font-semibold whitespace-nowrap ${
                      item.tag === 'NEW'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}